export const selectAutopubData = state => state.autopub.data

export const selectAutopubLoadingState = state => state.autopub.loading

export const selectAutopubError = state => state.autopub.error
